<!-- <app-header (toggle)="toggleSidebar()"></app-header>
<app-sidebar [open]="sidebarOpen"></app-sidebar>

<main class="content">
  <router-outlet></router-outlet>
</main> -->

<app-header (toggle)="toggleSidebar()"></app-header>
<app-sidebar
  [open]="sidebarOpen"
  (linkClicked)="handleSidebarLink()"
></app-sidebar>

<!-- Overlay that closes sidebar on outside click -->
<div
  class="sidebar-backdrop"
  *ngIf="sidebarOpen"
  (click)="toggleSidebar()"
></div>

<main class="content">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
